import Link from 'next/link';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import { FooterLink, ContactUs } from '@/ui/index';
import { BakcellFooterLogo } from '@/icons/index';
import Subscribe from '@/ui/Subscribe/Subscribe';
import { useBusiness } from '@/hooks/useBusiness';
import SocialNetwork from '../SocialNetwork/SocialNetwork';
import styles from './footer.module.scss';

const redirectAboutUs = ['ABOUT US', 'HAQQIMIZDA', 'О НАС'];
const redirectSupport = ['SUPPORT', 'DƏSTƏK', 'ПОМОЩЬ'];
const currentYear = new Date().getFullYear();

const Footer = ({ data }) => {
  const isBusiness = useBusiness();

  const renderFooterMenu = (item) => (
    <div
      key={item?.id}
      itemScope
      itemType='https://schema.org/SiteNavigationElement'
    >
      <li>
        <FooterLink list={item}>
          {redirectAboutUs.some((el) => item?.text?.includes(el)) && (
            <Link href={'/about-us'}>
              <a> {item?.text}</a>
            </Link>
          )}
          {redirectSupport.some((el) => item?.text?.includes(el)) && (
            <Link href={'/support'}>
              <a>{item?.text}</a>
            </Link>
          )}
          {![...redirectAboutUs, ...redirectSupport].some((el) =>
            item?.text?.includes(el),
          ) && item?.text}
        </FooterLink>
      </li>
    </div>
  );

  const renderSwitch = (item) => {
    switch (item?.type) {
      case 'download':
        return (
          <a
            className={styles.underLink}
            href={item?.button_download_file}
            title={item?.text}
            aria-label={item?.text}
          >
            {item?.text}
          </a>
        );
      default:
        return (
          <Link href={`/${item?.slug}`}>
            <a
              className={styles.underLink}
              title={item?.text}
              aria-label={item?.text}
            >
              {item?.text}
            </a>
          </Link>
        );
    }
  };

  const renderFooterUnderLinks = (item) => (
    <ul itemScope itemType='https://schema.org/SiteNavigationElement'>
      {renderSwitch(item)}
    </ul>
  );

  const { t } = useTranslation('common');

  return (
    <>
      <footer
        className={classNames(styles.footer, {
          [styles.footer__business]: isBusiness,
        })}
        itemScope
        itemType='https://schema.org/WPFooter'
      >
        <div className='wrapper'>
          <div className={styles.topBox}>
            <div className={styles.leftBox}>
              <div className={styles.fistList}>
                <Subscribe
                  buttonText={data?.subscribe_button_text}
                  title={data?.subscribe_section_title}
                  description={data?.subscribe_section_description}
                  placeholder={data?.subscribe_input_title}
                />
                <div className={styles.socialLinks}>
                  <SocialNetwork data={data?.social_media_links} />
                </div>
              </div>
            </div>
            <div className={styles.rightBox}>
              {!!data?.navigation_links?.length && (
                <ul className={styles.list}>
                  {data?.navigation_links?.map(renderFooterMenu)}
                  <div>
                    <ContactUs data={data?.contact_us} />
                  </div>
                </ul>
              )}
            </div>
          </div>
          <div className={styles.divider}></div>
          <div className={styles.bottomBox}>
            <div className={styles.bottomLeftBox}>
              <span className={styles.text}>
                {t('Copyright', {
                  year: currentYear,
                })}
              </span>
            </div>
            {/* <div className={styles.bottomRightBox}>
              {!!data?.bottom_links?.length && (
                <ul className={styles.infoItem}>
                  {data?.bottom_links?.map(renderFooterUnderLinks)}
                </ul>
              )}
            </div> */}
          </div>
        </div>
      </footer>
      <div
        className={styles.footerBottomWrapper}
        itemScope
        itemType='https://schema.org/SiteNavigationElement'
      >
        <BakcellFooterLogo
          className={classNames([
            styles.footerBtmImg,
            { [styles.dark]: isBusiness },
          ])}
        />
      </div>
    </>
  );
};

export default Footer;
